import { DEFAULT_PERMISSIONS } from '@/constants/constants';
import { UserConfigurationPermission } from '@/Interface/ticketManagementType';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PermissionsService } from '@services/permissions.service';
import { UtilityService } from '@services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { Subject, throwError } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-ticket-configuration',
  templateUrl: './ticket-configuration.component.html',
  styleUrls: ['./ticket-configuration.component.scss']
})
export class TicketConfigurationComponent implements OnInit {
  public userTypePermission: UserConfigurationPermission[] = [];
  public pageSizeControl = new FormControl(10);
  pageSize: number;
  pageToGo: number = 1;
  searchElement = '';
  serialNumberArray: Array<number> = [];
  next_page: number;
  current_page: number;
  previous_page: number;
  total_pages: number;
  total_items: number;
  private latestQueryParams: any = {};
  sortColumn: string = null;
  sortOrder: 'asc' | 'desc' = null;
  searchSubject: Subject<string> = new Subject();
  loader: boolean = false;
  tableLoader: boolean = false;

  public pageRecordOptions = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
    { value: '200', label: '200' },
  ];
  public selectedId: number;
  permissions = { ...DEFAULT_PERMISSIONS };
  permissionsReady: boolean = false;

  constructor(
    private _utilityService: UtilityService,
    private toaster: ToastrService,
    private permService: PermissionsService,
  ) { }

  ngOnInit(): void {
    this.getTableData();
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
      this.searchElement = searchTerm;
      this.updateQueryParams({ search: this.searchElement });
    });
    // this.initComponent()
  }
  async initComponent() {
    this.loader = true
    await this.getComponentPermissions();
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
      this.searchElement = searchTerm;
      this.updateQueryParams({ search: this.searchElement });
    });
    if (this.permissions.canView) {
      this.getTableData();
    }
  }
  async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }

  get hasAnyActionPermission(): boolean {
    return (
      this.permissionsReady &&
      (this.permissions.canView ||
        this.permissions.canEdit ||
        this.permissions.canDelete)
    );
  }

  onPermissionChange(item: UserConfigurationPermission, field: string, event: Event): void {
    const previousValue = !item[field]; // Store previous state

    // user_type: item.user_type,
    const payload = {
      id: item.id,
      [field]: item[field]
    };
    this._utilityService.updateCongfiguration(payload).pipe(
      catchError(error => {
        // Revert to previous state on error
        item[field] = previousValue;
        this.handleApiFieldErrors(error, this.toaster);
        return throwError(() => error);
      })
    ).subscribe(response => {
      if (response) {
        this.toaster.success(response.message || 'Permission updated successfully');
      }
    });
  }


  private updateQueryParams(paramsToUpdate: any): void {
    this.latestQueryParams = {
      ...this.latestQueryParams,
      ...paramsToUpdate
    };

    if (this.latestQueryParams.search === '') {
      this.latestQueryParams.search = null;
    }
    if (this.latestQueryParams.page === 1) {
      this.latestQueryParams.page = null;
    }
    if (this.latestQueryParams.size === 10) {
      this.latestQueryParams.size = null;
    }
    if (this.latestQueryParams.sort === null) {
      delete this.latestQueryParams.sort;
    }
    if (this.latestQueryParams.column === null) {
      delete this.latestQueryParams.column;
    }

    if (this.latestQueryParams.page === 1 || (this.latestQueryParams.page && (this.latestQueryParams.search))) {
      if (this.latestQueryParams.page > 1) {
        this.latestQueryParams.page = paramsToUpdate.page;
        if (this.latestQueryParams.size > 10) {
          this.latestQueryParams.size = paramsToUpdate.size;
        }
      } else {
        this.latestQueryParams.page = null;
      }
    }

    if (!this.next_page && (paramsToUpdate.size || paramsToUpdate.search)) {
      this.latestQueryParams = {
        size: paramsToUpdate.size || null,
        search: paramsToUpdate.search || null
      };
    }
    this.getTableData();
  }

  private getTableData(): void {
    const name = this.latestQueryParams['search'] || this.searchElement;
    const page = this.latestQueryParams['page'] ? +this.latestQueryParams['page'] : 1;
    const size = this.latestQueryParams['size'] ? +this.latestQueryParams['size'] : 10;
    const sort = this.latestQueryParams['sort'] || null;
    const column = this.latestQueryParams['column'] || null;
    this.getUserTypePermission(name, page, size, sort, column);
  }
  getUserTypePermission(name: string, page: number, size: number, sort: string | null, column: string | null): void {
    this.tableLoader = true;
    this.userTypePermission = [];
    this.serialNumberArray = [];
    this._utilityService
      .getCongfigurationList(name, page, size, sort, column)
      .subscribe((res: any) => {
        // && res['pagination']
        if (res && Array.isArray(res)) {
          this.userTypePermission = res.map((item: any, index: number) => ({
            ...item,
            srNo: index + 1
          }));

          // this.current_page = res.pagination.current_page;
          // this.next_page = res.pagination.next_page;
          // this.previous_page = res.pagination.previous_page;
          // this.total_pages = res.pagination.total_pages;
          // this.total_items = res.pagination.total_records;
          // this.enablePagination();
        }
        this.tableLoader = false;
      }, (error) => {
        this.tableLoader = false;
        this.toaster.error('Failed to load data');
      });
  }

  public searchData(event: Event): void {
    this.searchElement = (event.target as HTMLInputElement)?.value || '';
    this.searchSubject.next(this.searchElement);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.total_pages) {
      this.updateQueryParams({ page: page });
    }
  }

  navigatePage(direction: string): void {
    if (direction === 'prev' && this.current_page > 1) {
      this.goToPage(this.current_page - 1);
    } else if (direction === 'next' && this.next_page !== null) {
      this.goToPage(this.current_page + 1);
    }
  }

  navigateToPage(): void {
    if (this.pageToGo >= 1 && this.pageToGo <= this.total_pages) {
      this.goToPage(this.pageToGo);
    }
  }

  public changePageSize(): void {
    this.pageSize = this.pageSizeControl.value!;
    this.updateQueryParams({ size: this.pageSize });
  }

  enablePagination(): void {
    const linkElement = document.getElementById('prevPage');
    if (linkElement) {
      if (this.previous_page === null) {
        linkElement.setAttribute('disabled', 'true');
        linkElement.style.pointerEvents = 'none';
        linkElement.style.color = 'gray';
      } else {
        linkElement.removeAttribute('disabled');
        linkElement.style.pointerEvents = 'auto';
        linkElement.style.color = '';
      }
    }
  }

  handleApiFieldErrors(error: HttpErrorResponse, toastr: ToastrService): void {

    // Case 1: status is an array
    if (error.error?.status && Array.isArray(error.error.status)) {
      error.error.status.forEach((msg: string) => toastr.error(msg));
      return;
    }

    // Case 2: single message
    if (error.error?.message) {
      toastr.error(error.error.message);
      return;
    }

    // Case 3: field validation errors
    if (error.error?.errors) {
      Object.keys(error.error.errors).forEach(key => {
        const message = Array.isArray(error.error.errors[key])
          ? error.error.errors[key][0]
          : error.error.errors[key];
        toastr.error(message);
      });
      return;
    }

    // Case 4: rules array with non_field_errors
    if (Array.isArray(error.error?.rules)) {
      error.error.rules.forEach((rule: any) => {
        if (Array.isArray(rule?.non_field_errors)) {
          rule.non_field_errors.forEach((msg: string) => {
            toastr.error(msg);
          });
        }
      });
      return;
    }

    // Fallback
    toastr.error('Sorry, something went wrong. Please try again.');
  }

}